<template>
  <div>
    <img
      :src="resolvedImagePath"
      alt="Booking Image"
      class="img-fluid border-radius-default"
    />
  </div>
</template>

<script setup lang="ts">
  import { computed, defineProps } from 'vue'
  import { getImagePath } from '@/utils'
  import fallbackImage from '@/assets/no-img.jpg'

  const props = defineProps({
    image: {
      type: String,
      required: false,
    },
  })

  const resolvedImagePath = computed(() =>
    props.image ? getImagePath(props.image) : fallbackImage
  )
</script>

<style scoped>
  .border-radius-default {
    border-radius: var(--border-radius-default);
  }
</style>
